/*
 * @Date: 2023-11-01 13:37:21
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-03-18 22:04:02
 * @FilePath: /nicee-web-tw/src/components/VoiceRoom/seatProvider.js
 * @Description: 语音房麦位
 */
import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
import currentUserProvider from './currentUserProvider';
import {
  applyMic as applyMicRequest,
  hostTakeSeat,
  getRoomSeat,
  changeSeat,
  leaveSeat,
  forceLeaveMic,
  cancelApplyMic
} from '@/api/voice-room';

// class SeatItemInfo {
//   avatarURL = ''; //
//   bubble_BOX = ''; //
//   mic = 0; //1开0关
//   nickname = ''; //
//   pfpFrame = ''; //
//   roomUid = ''; //
//   seatIndex = 0; //
//   sex = ''; //
//   userUuid = ''; //
//   userLevel = ''; //
//   spendAmount = 0;
//   rankingScore = 0;
//   uniqueMic = null;
//   time = null;
// }
class Seat {
  list = []; //麦位列表
  isApplyMic = false; //是否正在申请上麦
  applyMicLoading = false; // 申请上麦loading
  roomId = null; //房间id
  time = 0;
  get currentUserSeatInfo() {
    return this.userProvider.seatInfo;
  }
  get isOnSeat() {
    return this.currentUserSeatInfo && this.currentUserSeatInfo.userUuid;
  }
  // 当前用户麦位下标
  get seatIndex() {
    return this.list.findIndex(item => {
      if (
        item &&
        this.currentUserSeatInfo &&
        this.currentUserSeatInfo.userUuid &&
        this.userProvider &&
        this.userProvider.isCurrentUser(item.userUuid)
      ) {
        return true;
      } else {
        return false;
      }
    });
  }
  get emptySeatIndex() {
    const index = this.list.slice(1).findIndex(item => {
      return !item.userUuid;
    });
    return index === -1 ? index : index + 1;
  }
  //是否是主持人
  get isHost() {
    return this.seatIndex === 0;
  }
  constructor(userProvider) {
    this.userProvider = userProvider;
  }

  init(roomId) {
    this.roomId = roomId;
  }
  /**
   * @description: 设置麦位列表
   * @param {*} seatList
   * @return {*}
   */
  setList(seatList) {
    const list = [];
    for (let i = 0; i < 9; i++) {
      list.push({});
    }
    if (seatList && seatList.length) {
      seatList.forEach(item => {
        if (item && item.seatIndex != undefined) {
          list[item.seatIndex] = item;
        }
        if (item && item.userUuid) {
          if (
            !this.list.find(oVal => {
              return oVal &&  oVal.userUuid === item.userUuid;
            })
          ) {
            VoiceRoomEventEmitter.emit(VoiceRoomEvent.userEnterSeat, item);
          }
        }
      });
    }
    this.list = list.slice(0, 9);
  }

  /**
   * @description: 上主持人位
   * @return {*}
   */
  // async hostTakeSeat(seatInfo) {
  //   let params = {};
  //   params['roomUid'] = this.roomId;
  //   params['action'] = 'BecomeHost';
  //   params['targetUuid'] = seatInfo.userUuid;
  //   params['seatIndex'] = 0;
  //   try {
  //     await hostTakeSeat(params);
  //     seatInfo.seatIndex = 0;
  //     await this.changeSeat(this.roomId, 0);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  async hostTakeSeat(userUuid) {
    let params = {};
    params['roomUid'] = this.roomId;
    params['action'] = 'BecomeHost';
    params['targetUuid'] = userUuid;
    params['seatIndex'] = 0;
    try {
      await hostTakeSeat(params);
      // seatInfo.seatIndex = 0;
      await this.changeSeat(this.roomId, 0);
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * @description: 同意上麥
   * @param {*} seatIndex
   * @param {*} userInfo
   * @param {*} dressup
   * @param {*} pfpFrame
   * @return {*}
   */

  agreeSeat(seatIndex) {
    this.changeSeat(this.roomId, seatIndex);
  }

  /**
   * @description: 改变麦位位置
   * @return {*}
   */
  async changeSeat(roomId, seatIndex) {
    await changeSeat({
      roomUid: roomId,
      seatIndex: seatIndex
    });
  }

  /**
   * @description: 离开麦位
   * @return {*}
   */
  async leaveSeat() {
    const params = {};
    params['roomUid'] = this.roomId;
    params['action'] = 'DropMic';
    params['playerQueue'] = false;
    params['seatNum'] = this.seatIndex;
    console.log(params);
    await leaveSeat(params);
  }
  /**
   * @description: 踢下麦
   * @return {*}
   */

  async forceLeaveMic(index, targetUuid) {
    const params = {};
    params['roomUid'] = this.roomId;
    params['action'] = 'ForceLeaveMic';
    params['seatIndex'] = index;
    params['targetUuid'] = targetUuid;
    await forceLeaveMic(params);
  }

  /**
   * @description: 初始化单个麦位
   * @return {*}
   */
  initSeatItem(index) {
    this.list[index] = {};
    this.list = [...this.list];
  }
  /**
   * @description: 更新当前用户的麦位资料
   * @return {*}
   */
  updateUserSeatInfo() {
    const isOnSeat = this.userProvider.isOnSeat;
    const userSeatInfo = this.list.find(item => {
      if (item && this.userProvider.isCurrentUser(item.userUuid)) {
        return true;
      } else {
        return false;
      }
    });
    this.userProvider.updateSeat(userSeatInfo);
    // 申请上麦通过
    if (!isOnSeat && userSeatInfo) {
      VoiceRoomEventEmitter.emit(VoiceRoomEvent.enterSeat);
    }
    // 离开麦位
    if (isOnSeat && !userSeatInfo) {
      VoiceRoomEventEmitter.emit(VoiceRoomEvent.leaveSeat);
    }
  }
  /**
   * @description: 开启上麦loading
   * @return {*}
   */
  setApplyMicLoading() {
    this.applyMicLoading = true;
  }
  /**
   * @description: 关闭上麦loading
   * @return {*}
   */
  closeApplyMicLoading() {
    this.applyMicLoading = false;
  }

  /**
   * @description: 申请上麦
   * @param {*} seatIndex
   * @return {*}
   */
  async applyMic(seatIndex) {
    if (this.isOnSeat) {
      this.changeSeat(this.roomId, seatIndex);
    } else {
      if (this.applyMicLoading) {
        return;
      }
      const params = {};
      params['roomUid'] = this.roomId;
      params['action'] = 'AskForMic';
      params['playerQueue'] = false;
      if (seatIndex !== undefined) {
        params['seatNum'] = seatIndex;
      }
      this.setApplyMicLoading();
      await applyMicRequest(params);
      this.closeApplyMicLoading();
      this.isApplyMic = true;
      return true;
    }
  }

  /**
   * @description: 取消申请上麦
   * @param {*} seatIndex
   * @return {*}
   */

  async cancelApplyMic() {
    const params = {};
    params['roomUid'] = this.roomId;
    params['action'] = 'CancelAskForMic';
    params['playerQueue'] = false;
    this.isApplyMic = false;
    await cancelApplyMic(params);
    return true;
  }

  /**
   * @description: 获取麦位下标
   * @param {*} userId
   * @return {*}
   */
  getSeatIndex(userId) {
    return this.list.findIndex(item => {
      return item && item.userUuid === userId;
    });
  }
  /**
   * @description: 获取麦位
   * @param {*} userId
   * @return {*}
   */
  getSeatInfo(userId) {
    return this.list.find(item => {
      return item && item.userUuid === userId;
    });
  }

  /**
   * @description: 获取麦位列表
   * @return {*}
   */

  async getSeatList() {
    try {
      const { data } = await getRoomSeat({ roomUid: this.roomId });
      this.setList(data.seats);
      SeatProvider.updateUserSeatInfo();
      console.log('getSeatList', data);
    } catch (error) {
      console.log(error);
    }
  }
  async onSeatChange(data) {
    const { time, seats } = data;
    this.time = time;
    this.setList(seats);
  }
  // 清理麦位
  clearSeat(index) {
    this.initSeatItem(index);
    this.updateUserSeatInfo();
  }

  //更新魅力值
  updateScore(members) {
    if (members && members.length) {
      this.list.forEach(item => {
        const user = members.find(member => {
          return member.userUuid === item.userUuid;
        });
        if (user) {
          item.rankingScore = user.rankingScore;
        }
      });
      this.list = [...this.list];
    }
  }
}
const SeatProvider = new Seat(currentUserProvider);
VoiceRoomEventEmitter.on(VoiceRoomEvent.onSeatChange, data => {
  SeatProvider.onSeatChange(data);
  SeatProvider.updateUserSeatInfo();
});
VoiceRoomEventEmitter.on(VoiceRoomEvent.clearSeat, index => {
  SeatProvider.clearSeat(index);
});
export default SeatProvider;
